import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { SaveButton } from "../../../../components/Buttons";

export const MilliOn = () => {
    document.title = "Milli Ön";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Ödəniş", value: "/settings/payment" },
        { name: "Milli Ön", value: "/settings/payment/million", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Milli ön ödəmə sistemi ilə ödəniş qaydası</h2>
                    <p>
                        Profil balansını artırmaq üçün Milli ön ödəmə sistemində aşağıdakı ardıcıllığa əməl etmək lazımdır
                        <ol>
                            <li>
                                Milli ön ödəmə sistemində <mark>Elektron pul kisəsi</mark>nə daxil olun.
                            </li>
                            <li>
                                <mark>Yığım</mark> ödəniş sistemini seçin.
                            </li>
                            <li>
                                <mark>Digər xidmətlər</mark> seçimini edin
                            </li>
                            <li>
                                <mark>Bein Systems</mark> seçin
                            </li>
                            <li>
                                Qeydiyyatdan keçdiyiniz telefon nömrəsini yazın və <SaveButton>irəli</SaveButton> düyməsini sıxın
                            </li>
                            <li>
                                Əskinazları daxil edin və <SaveButton>irəli</SaveButton> düyməsini sıxın
                            </li>
                        </ol>
                        <b>Qeyd</b>: Ödəniş zamanı komissiya haqqı tutulmur.
                    </p>
                    <img src="/images/settings/payment/million-1.gif" alt="Milli Ön" />

                    <h2 className="my-4">Sistemə daxil olmadan ödəniş qaydası</h2>
                    <p>
                        Profil balansını bitdikdə, sistemə daxil ola bilmədikdə balansı artırmaq üçün aşağıdakı ardıcıllığa əməl etmək lazımdır
                        <ol>
                            <li>
                                <a href={"https://bein.az"}>Bein.az</a> saytına daxil olduqdan sonra,{" "}
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-left" viewBox="0 0 16 16">
                                    <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"></path>
                                </svg>{" "}
                                <b>texniki dəstək</b> düyməsini sıxın və açılan pəncərədə seçimini edin.
                            </li>
                            <li>
                                Açılan dialoq pəncərəsində{" "}
                                <button style={{ background: "red", color: "#fff", borderRadius: "5px", borderColor: "#c2bcbc" }}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#fff"
                                        color="red"
                                        class="bi bi-credit-card-2-front"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"></path>
                                        <path d="M2 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"></path>
                                    </svg>{" "}
                                    Balans artır
                                </button>{" "}
                                seçimini edin
                            </li>
                            <li>
                                Növbəti mərhələdə istifadəçi, <b>Milli Ön</b> ödəmə sisteminə yönləndiriləcək. Qeydiyyatdan keçdiyiniz nömrəni daxil edib{" "}
                                <SaveButton>irəli</SaveButton> düyməsini sıxın.
                            </li>
                            <li>
                                Ödəyəcəyiniz məbləği qeyd edib <SaveButton>irəli</SaveButton> düyməsini sıxın.
                            </li>
                            <li>
                                Qeydiyyatdan keçdiyiniz telefon nömrəsini yazın və <SaveButton>irəli</SaveButton> düyməsini sıxın
                            </li>
                            <li>
                                Kart məlumatlarını daxil etmək üçün açılan pəncərədə məlumatlar daxil edilib <SaveButton>ödə</SaveButton> düyməsini sıxın.
                            </li>
                        </ol>
                        <b>Qeyd</b>: Ödəniş zamanı komissiya haqqı tutulmur.
                    </p>
                    <img src="/images/settings/payment/million-2.gif" alt="Milli Ön" />
                </article>
            </div>
        </div>
    );
};
